import { render, staticRenderFns } from "./BrandComponent.vue?vue&type=template&id=b7cb53da&scoped=true"
import script from "./BrandComponent.vue?vue&type=script&lang=js"
export * from "./BrandComponent.vue?vue&type=script&lang=js"
import style0 from "./BrandComponent.vue?vue&type=style&index=0&id=b7cb53da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cb53da",
  null
  
)

export default component.exports